/*
 * IG menu drawer — panel navigation + close button
 * Madrid's `MenuDrawer` connectedCallback binds an `onCloseButtonClick` handler
 * to every <button> inside the drawer, which would collapse the entire drawer
 * whenever the user taps an "open panel" or "back" button. We intercept at
 * capture phase and stop propagation for our own controls so Madrid's per-
 * button handler never fires for them.
 */
(function () {
  'use strict';

  function closeDrawer(drawerEl) {
    const details = drawerEl.closest('details.menu-drawer-container');
    if (!details) return;
    const summary = details.querySelector('summary');
    if (details.hasAttribute('open') && summary) {
      summary.click();
    }
  }

  function switchPanel(drawerEl, targetKey) {
    const panels = drawerEl.querySelector('.ig-menu-drawer__panels');
    if (!panels) return;
    panels.setAttribute('data-active-panel', targetKey);
    panels.querySelectorAll('.ig-menu-drawer__panel').forEach((panel) => {
      const active = panel.dataset.panel === targetKey;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.classList.toggle('is-active', active);
    });
    // Reset scroll for the incoming panel.
    const target = panels.querySelector(
      '.ig-menu-drawer__panel[data-panel="' + CSS.escape(targetKey) + '"]'
    );
    if (target) target.scrollTop = 0;
  }

  function handle(event) {
    const drawerEl = event.target.closest('.ig-menu-drawer');
    if (!drawerEl) return;

    const openBtn = event.target.closest('[data-ig-open-panel]');
    if (openBtn) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      switchPanel(drawerEl, openBtn.dataset.igOpenPanel);
      return;
    }
    const backBtn = event.target.closest('[data-ig-back]');
    if (backBtn) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      switchPanel(drawerEl, backBtn.dataset.igBack || 'root');
      return;
    }
    const closeBtn = event.target.closest('[data-ig-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer(drawerEl);
    }
  }

  function init() {
    // Capture phase — runs before Madrid's per-button close handler.
    document.addEventListener('click', handle, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
